<template>
  <a-table
    :dataSource="data"
    :pagination='paginationOptions'
    @change='onChange'
    :locale='{ emptyText: "Nothing here..." }'
    v-bind="$attrs"
    :scroll="{ x: 1300 }">
    <slot></slot>
  </a-table>

</template>

<script>
export default {
  inheritAttrs: false,
  props: ['data', 'columns', 'onChange', 'totalRows', 'pagination'],
  computed: {
    paginationOptions() {
      const defaults = { hideOnSinglePage: true, pageSize: 24, total: (this.totalRows || this.data.length || 0) }
      return Object.assign({}, this.pagination || {}, defaults)
    }
  }
}
</script>

<style lang='stylus'>
.ant-table-row-level-1 {
  background-color: #F6F6F6;
}

&.ant-table-wrapper {
  background-color: $white;
  position: relative;
  border-radius: 4px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.25);
  font-size: 12px;
}

.ant-table-thead {
  > tr > th {
    background-color: #51c6e5;
    padding: 12px 20px 8px;
  }
}

.ant-table-thead > tr > th, .ant-table-tbody > tr > td {
  word-break: unset;
  white-space: nowrap;
  font-weight: 100;
}

.ant-table-thead > tr > th {
  border-right: 1px solid #28a7c8;
  &:last-child {
    border-right: none;
  }
  border-bottom: 1px solid #51c6e5;
  > div {
    color: $white;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 12px;
  }
}

.ant-table-scroll {
  border-radius: 4px;
  .ant-table-thead {
    background-color: #51c6e5;
    > tr > th {
      background-color: transparent;
    }
  }
}

.ant-table-fixed-left {
  .ant-table-thead {
    border-right: 1px solid #28a7c8;
  }
  .ant-table-tbody {
    border-right: 1px solid #E6E6E6;
  }
}

.ant-table-row {
  height: auto;
  position: relative;
}

.ant-table-row > td {
  padding: 20px;
  &.custom {
    padding: 0px;
  }
  border-right: 1px solid #E6E6E6;
  &:last-child {
    border-right: none;
  }
  > div {
    display: flex;
    align-items: center;
  }
}
.ant-table-row-level-0 > td > div {
  height: 62px;
}

.ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
  background: rgba(0, 0, 0, 0.02); //row hover
}

.ant-table-placeholder {
  height: 60px;
}

tr.ant-table-expanded-row, tr.ant-table-expanded-row:hover {
  background: #F6F6F6;
  box-shadow: inset 0 8px 5px -5px #E9E9E9;
}

.ant-table-thead  > tr > th {
  .ant-table-column-sorters {
    display: inline-flex;
  }

  .ant-table-column-sorter {
    color: transparent;
  }

  &:hover .ant-table-column-sorter {
    color: rgba(255, 255, 255, 0.5);
  }
}

.ant-table-thead > tr > th.ant-table-column-sort {
  &, &:hover {
    background: $secondaryBlue;
  }
}

.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters:active .ant-table-column-sorter-up:not(.on), .ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters:active .ant-table-column-sorter-down:not(.on) {
  color: rgba(255, 255, 255, 0.5);
}

.ant-table-thead > tr > th .ant-table-column-sorter-up.on, .ant-table-thead > tr > th .ant-table-column-sorter-down.on {
  color: $white;
}

.ant-table-spin-holder .ant-spin-dot {
  width: 32px;
  height: 32px;

  svg {
    width: 100%;
    height: 100%;
  }
}

.ant-table-pagination.ant-pagination {
  width: 100%;
  background: #f4f4f4;
  height: 100%;
  margin: 0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  padding: 20px 0;
  display: flex;
  justify-content: center;
}
</style>